import React from "react";
import { Layout, Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";

import {
  ArrowRightLeft,
  Bell,
  CircleDollarSign,
  ClipboardCheck,
  Club,
  Component,
  Contact,
  Dumbbell,
  GraduationCap,
  LayoutDashboard,
  Mail,
  Palette,
  UserRound,
  Lightbulb,
} from "lucide-react";

import SplendedLogo from "../assets/logo/splended_logo.png";
import { useTranslation } from "react-i18next";

const { Sider } = Layout;

const MOBILE_BREAKPOINT = 992;

const Sidebar = ({ isSidebarVisible, onCloseSidebar }) => {
  const { t } = useTranslation();
  const location = useLocation();

  if (!isSidebarVisible) return null;

  const handleNavClick = () => {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      onCloseSidebar?.();
    }
  };

  const menuItems = [
    {
      key: "/dashboard",
      label: t("sidebar.dashboard"),
      icon: <LayoutDashboard />,
    },
    { key: "/users", label: t("sidebar.userManager"), icon: <UserRound /> },
    {
      key: "/theme",
      label: t("sidebar.themeManager"),
      icon: <Palette />,
    },
    {
      key: "/themecomponent",
      label: t("sidebar.themeComponentManager"),
      icon: <Component />,
    },
    {
      key: "/exercise",
      label: t("sidebar.exerciseContentManager"),
      icon: <Dumbbell />,
    },
    { key: "/clubs", label: t("sidebar.clubManager"), icon: <Club /> },
    // {
    //   key: "/didactics",
    //   label: t("sidebar.didacticsManager"),
    //   icon: <GraduationCap />,
    // },
    {
      key: "/subscriptionprice",
      label: t("sidebar.subscriptionPriceManager"),
      icon: <CircleDollarSign />,
    },
    {
      key: "/subscriptiontransaction",
      label: t("sidebar.subscriptionTransactionManager"),
      icon: <ArrowRightLeft />,
    },
    {
      key: "/notification",
      label: t("sidebar.notificationManager"),
      icon: <Bell />,
    },
    {
      key: "/content",
      label: t("sidebar.contentManager"),
      icon: <ClipboardCheck />,
    },
    {
      key: "/emailtemplate",
      label: t("sidebar.emailTemplateManager"),
      icon: <Mail />,
    },
    {
      key: "/user-sessions",
      label: t("sidebar.userSessions"),
      icon: <Contact />,
    },

    {
      key: "/tip-sessions",
      label: t("sidebar.tipSessions"),
      icon: <Lightbulb />,
    },
    {
      key: "/club-migrate",
      label: t("sidebar.clubMigrate"),
      icon: <Contact />,
    },
  ];

  return (
    <Sider
      width={300}
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 999,
        height: "100vh",
        overflow: "auto",
        background: "#fff",
        boxShadow: "2px 0 4px rgba(0,0,0,0.1)",
      }}
    >
      {/* Logo - Clickable to Dashboard */}
      <div onClick={handleNavClick} style={{ cursor: "pointer" }}>
        <NavLink to="/dashboard" style={{ textDecoration: "none" }}>
          <div
            style={{
              padding: "20px 0",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <img
              src={SplendedLogo}
              width={80}
              alt="Admin Logo"
              style={{ margin: "0 auto" }}
            />
          </div>
        </NavLink>
      </div>

      <div className="sidebar-menu">
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          style={{ height: "100%", borderRight: 0, padding: "0 8px" }}
          items={menuItems.map((item) => ({
            key: item.key,
            icon: item.icon,
            label: (
              <div onClick={handleNavClick}>
                <NavLink
                  to={item.key}
                  className="sidebarmenu-item"
                  title={item.label}
                >
                  {item.label}
                </NavLink>
              </div>
            ),
          }))}
        />
      </div>
    </Sider>
  );
};

export default Sidebar;
